import * as Constants from '../../constants/resources';
import {
  CertificateData,
  Certificates,
  CertProperties,
  Environments,
  ReplaceCertificate
} from '../../types/resources/State';

export interface RequestCertificates {
  type: Constants.CERTIFICATES;
  payload: {
    from: number;
    pageSize: number;
    filter: string;
  };
}

export interface RequestCertificatesSuccess {
  type: Constants.CERTIFICATES_SUCCESS;
  payload: {
    certificates: Certificates;
  };
}

export interface RequestCertificatesFailed {
  type: Constants.CERTIFICATES_FAILED;
}
export interface RequestDeleteCertificate {
  payload: { certificate: CertProperties };
  type: Constants.DELETE_CERTIFICATE;
}

export interface RequestReplaceCertificate {
  payload: ReplaceCertificate;
  type: Constants.REPLACE_CERTIFICATE;
}

export interface RequestDeleteCertificateSuccess {
  type: Constants.DELETE_CERTIFICATE_SUCCESS;
  payload: { certificate: any };
}
export interface RequestDeleteCertificateFailed {
  type: Constants.DELETE_CERTIFICATE_FAILED;
  payload: { certificate: CertProperties };
}

export interface RequestReplaceCertificateSuccess {
  type: Constants.REPLACE_CERTIFICATE_SUCCESS;
}

export interface RequestReplaceCertificateFailed {
  type: Constants.REPLACE_CERTIFICATE_FAILED;
  error: string;
}

export interface RequestCertificateDetail {
  type: Constants.CERTIFICATE_DETAIL;
  certificateVMID: string;
}

export interface RequestCertificateDetailSuccess {
  type: Constants.CERTIFICATE_DETAIL_SUCCESS;
  payload: {
    certificateDetail: CertificateData;
  };
}
export interface RequestCertificateDetailFailed {
  type: Constants.CERTIFICATE_DETAIL_FAILED;
}

export interface RequestCertificateReferences {
  type: Constants.CERTIFICATE_REFERENCES;
  certificateVMID: string;
}

export interface RequestCertificateReferencesSuccess {
  type: Constants.CERTIFICATE_REFERENCES_SUCCESS;
  payload: {
    certificateReferences: Environments;
  };
}
export interface RequestCertificateReferencesFailed {
  type: Constants.CERTIFICATE_REFERENCES_FAILED;
}

export type CertificateAction =
  | RequestCertificates
  | RequestCertificatesSuccess
  | RequestCertificateDetail
  | RequestCertificateDetailSuccess
  | RequestCertificateDetailFailed
  | RequestCertificateReferences
  | RequestCertificateReferencesSuccess
  | RequestCertificateReferencesFailed
  | RequestDeleteCertificate
  | RequestDeleteCertificateSuccess
  | RequestDeleteCertificateFailed
  | RequestCertificatesFailed
  | RequestReplaceCertificate
  | RequestReplaceCertificateSuccess
  | RequestReplaceCertificateFailed;

export const requestCertificates = (
  from: number,
  pageSize: number,
  filter: string
): RequestCertificates => ({
  type: Constants.CERTIFICATES,
  payload: { from, pageSize, filter }
});
export const requestCertificatesSuccess = (
  certificates: Certificates
): RequestCertificatesSuccess => ({
  payload: { certificates },
  type: Constants.CERTIFICATES_SUCCESS
});
export const requestCertificatesFailed = (): RequestCertificatesFailed => ({
  type: Constants.CERTIFICATES_FAILED
});

export const requestDeleteCertificate = (
  certificate: any
): RequestDeleteCertificate => ({
  payload: { certificate },
  type: Constants.DELETE_CERTIFICATE
});

export const requestReplaceCertificate = (
  replaceCertificate: ReplaceCertificate
): RequestReplaceCertificate => ({
  payload: replaceCertificate,
  type: Constants.REPLACE_CERTIFICATE
});

export const requestDeleteCertificateSuccess = (
  payload: any
): RequestDeleteCertificateSuccess => ({
  payload,
  type: Constants.DELETE_CERTIFICATE_SUCCESS
});
export const requestDeleteCertificateFailed = (
  payload: any
): RequestDeleteCertificateFailed => ({
  payload,
  type: Constants.DELETE_CERTIFICATE_FAILED
});

export const requestReplaceCertificateSuccess = (): RequestReplaceCertificateSuccess => ({
  type: Constants.REPLACE_CERTIFICATE_SUCCESS
});

export const requestReplaceCertificateFailed = (
  error: string
): RequestReplaceCertificateFailed => ({
  error,
  type: Constants.REPLACE_CERTIFICATE_FAILED
});

export const requestCertificateDetail = (
  certificateVMID: string
): RequestCertificateDetail => ({
  type: Constants.CERTIFICATE_DETAIL,
  certificateVMID
});

export const requestCertificateDetailSuccess = (
  certificateDetail: CertificateData
): RequestCertificateDetailSuccess => ({
  payload: { certificateDetail },
  type: Constants.CERTIFICATE_DETAIL_SUCCESS
});
export const requestCertificateDetailFailed = (): RequestCertificateDetailFailed => ({
  type: Constants.CERTIFICATE_DETAIL_FAILED
});
export const requestCertificateReferences = (
  certificateVMID: string
): RequestCertificateReferences => ({
  type: Constants.CERTIFICATE_REFERENCES,
  certificateVMID
});

export const requestCertificateReferencesSuccess = (
  certificateReferences: Environments
): RequestCertificateReferencesSuccess => ({
  payload: { certificateReferences },
  type: Constants.CERTIFICATE_REFERENCES_SUCCESS
});
export const requestCertificateReferencesFailed = (): RequestCertificateReferencesFailed => ({
  type: Constants.CERTIFICATE_REFERENCES_FAILED
});
